import * as tslib_1 from "tslib";
import { _rgbaOrHexString } from './_rgbaOrHexString';
/**
 * Gets a color with the given alpha value and the same other components as `color`.
 * Does not modify the original color.
 */
export function updateA(color, a) {
    return tslib_1.__assign({}, color, { a: a, str: _rgbaOrHexString(color.r, color.g, color.b, a, color.hex) });
}
//# sourceMappingURL=updateA.js.map